export default "__VITE_ASSET__BNPOo5tB__"